const ERROR_TRANSLATIONS = {
  cortex_processing_reconciliation_invalid: t =>
    t('CORTEX_BUDGET_RECONCILIATION.ERRORS.INVALID'),
  cortex_processing_reconciliation_evidence_required: t =>
    t('CORTEX_BUDGET_RECONCILIATION.ERRORS.EVIDENCE_REQUIRED'),
  cortex_processing_reconciliation_not_pending: t =>
    t('CORTEX_BUDGET_RECONCILIATION.ERRORS.NOT_PENDING'),
  cortex_processing_reconciliation_in_progress: t =>
    t('CORTEX_BUDGET_RECONCILIATION.ERRORS.IN_PROGRESS'),
  cortex_processing_configuration_changed: t =>
    t('CORTEX_PROCESSING_ERRORS.CONFIGURATION_CHANGED'),
  cortex_processing_budget_invalid_limit: t =>
    t('CORTEX_PROCESSING_ERRORS.BUDGET_INVALID_LIMIT'),
  cortex_processing_budget_reason_required: t =>
    t('CORTEX_PROCESSING_ERRORS.BUDGET_REASON_REQUIRED'),
  cortex_processing_budget_invalid_renewal: t =>
    t('CORTEX_PROCESSING_ERRORS.BUDGET_INVALID_RENEWAL'),
  cortex_processing_budget_unverified: t =>
    t('CORTEX_PROCESSING_ERRORS.BUDGET_UNVERIFIED'),
  cortex_processing_budget_cancelled: t =>
    t('CORTEX_PROCESSING_ERRORS.BUDGET_CANCELLED'),
  cortex_processing_budget_below_committed: t =>
    t('CORTEX_PROCESSING_ERRORS.BUDGET_BELOW_COMMITTED'),
  cortex_processing_empty_selection: t =>
    t('CORTEX_PROCESSING_ERRORS.EMPTY_SELECTION'),
  cortex_processing_agent_inbox_missing: t =>
    t('CORTEX_PROCESSING_ERRORS.AGENT_INBOX_MISSING'),
  cortex_processing_knowledge_base_missing: t =>
    t('CORTEX_PROCESSING_ERRORS.KNOWLEDGE_BASE_MISSING'),
  cortex_processing_invalid_period: t =>
    t('CORTEX_PROCESSING_ERRORS.INVALID_PERIOD'),
  cortex_processing_invalid_message_selection: t =>
    t('CORTEX_PROCESSING_ERRORS.INVALID_MESSAGE_SELECTION'),
  cortex_processing_preview_invalid: t =>
    t('CORTEX_PROCESSING_ERRORS.PREVIEW_INVALID'),
  cortex_processing_preview_stale: t =>
    t('CORTEX_PROCESSING_ERRORS.PREVIEW_STALE'),
  cortex_processing_budget_exceeded: t =>
    t('CORTEX_PROCESSING_ERRORS.BUDGET_EXCEEDED'),
  cortex_processing_authorization_expired: t =>
    t('CORTEX_PROCESSING_ERRORS.AUTHORIZATION_EXPIRED'),
};

const PREVIEW_REFRESH_ERRORS = new Set([
  'cortex_processing_preview_invalid',
  'cortex_processing_preview_stale',
]);

export const cortexProcessingErrorCode = error =>
  error?.response?.data?.errors?.[0];

export const cortexProcessingErrorMessage = (error, t, fallbackMessage) => {
  const translation = ERROR_TRANSLATIONS[cortexProcessingErrorCode(error)];
  return translation ? translation(t) : fallbackMessage;
};

export const cortexProcessingPreviewRequiresRefresh = error =>
  PREVIEW_REFRESH_ERRORS.has(cortexProcessingErrorCode(error));
